// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m7-1";
export var messageSideRight = "_m7-2";
export var orderLookupBubbleContainer = "_m7-0";
export var submitButton = "_m7-3";